var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatronIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 55,
    viewBox: "0 0 60 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 51.5V45.5C33 37.2157 26.2843 30.5 18 30.5C9.71573 30.5 3 37.2157 3 45.5V51.5H33ZM33 51.5H57V48.5C57 39.6634 50.2843 33.5 42 33.5C37.76 33.5 33.9309 35.3765 31.2028 38.3933M27 12.5C27 17.4706 22.9706 21.5 18 21.5C13.0294 21.5 9 17.4706 9 12.5C9 7.52944 13.0294 3.5 18 3.5C22.9706 3.5 27 7.52944 27 12.5ZM48 18.5C48 21.8137 45.3137 24.5 42 24.5C38.6863 24.5 36 21.8137 36 18.5C36 15.1863 38.6863 12.5 42 12.5C45.3137 12.5 48 15.1863 48 18.5Z",
    stroke: "#11C0F2",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatronIcon);
export default __webpack_public_path__ + "static/media/PatronIcon.e4dd72119f458fe8093ef356b2e9d98e.svg";
export { ForwardRef as ReactComponent };